import { render } from "./detailFooter.vue?vue&type=template&id=5ee6597b&scoped=true&ts=true"
import script from "./detailFooter.vue?vue&type=script&lang=ts"
export * from "./detailFooter.vue?vue&type=script&lang=ts"

import "./detailFooter.vue?vue&type=style&index=0&id=5ee6597b&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee6597b"]])

export default __exports__